"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizPortalWebClientRequesterGeneratorClass = exports.SessionManager = exports.AuthenticationManager = exports.Page = exports.OrderClauses = exports.GetItemsParams = exports.Filter = exports.VizPortalWebClientRequester = exports.getSuccessResult = exports.getErrors = exports.isResultWithErrors = void 0;
var vizPortalWebClientHelpers_1 = require("./api/vizPortalWebClientHelpers");
Object.defineProperty(exports, "isResultWithErrors", { enumerable: true, get: function () { return vizPortalWebClientHelpers_1.isResultWithErrors; } });
Object.defineProperty(exports, "getErrors", { enumerable: true, get: function () { return vizPortalWebClientHelpers_1.getErrors; } });
Object.defineProperty(exports, "getSuccessResult", { enumerable: true, get: function () { return vizPortalWebClientHelpers_1.getSuccessResult; } });
var VizPortalWebClientRequester_1 = require("./api/VizPortalWebClientRequester");
Object.defineProperty(exports, "VizPortalWebClientRequester", { enumerable: true, get: function () { return VizPortalWebClientRequester_1.VizPortalWebClientRequester; } });
var Filter_1 = require("./common/Filter");
Object.defineProperty(exports, "Filter", { enumerable: true, get: function () { return Filter_1.Filter; } });
var GetItemsParams_1 = require("./common/GetItemsParams");
Object.defineProperty(exports, "GetItemsParams", { enumerable: true, get: function () { return GetItemsParams_1.GetItemsParams; } });
var Order_1 = require("./common/Order");
Object.defineProperty(exports, "OrderClauses", { enumerable: true, get: function () { return Order_1.OrderClauses; } });
var Page_1 = require("./common/Page");
Object.defineProperty(exports, "Page", { enumerable: true, get: function () { return Page_1.Page; } });
var AuthenticationManager_1 = require("./managers/AuthenticationManager");
Object.defineProperty(exports, "AuthenticationManager", { enumerable: true, get: function () { return AuthenticationManager_1.AuthenticationManager; } });
var SessionManager_1 = require("./managers/SessionManager");
Object.defineProperty(exports, "SessionManager", { enumerable: true, get: function () { return SessionManager_1.SessionManager; } });
__exportStar(require("./requester/WebClientFetchRequester"), exports);
__exportStar(require("./requester/webClientMethod"), exports);
__exportStar(require("./requester/webClientRequest"), exports);
__exportStar(require("./requester/webClientRequester"), exports);
__exportStar(require("./requester/webClientResponse"), exports);
// Exporting VizPortalWebClientRequesterGenerator wrapped in a class for the VizClient Saltarelle code,
// which doesn't allow functions to exist outside of classes.
var VizPortalWebClientRequesterGeneratorClass = require("./util/vizPortalWebClientRequesterGenerator");
exports.VizPortalWebClientRequesterGeneratorClass = VizPortalWebClientRequesterGeneratorClass;
//# sourceMappingURL=index.js.map